<template>
  <div class="data-table__wrap" :class="{ mobile: mobileCardLayoutEnabled }">
    <LvCardList
      v-if="isCardLayout"
      :items="_cardList"
      class="card-container"
      @click-item="$_dataClick($event.rowItem)"
      @click-icon-btn="$emit('click-icon-btn', $event)"
    />
    <div v-else class="data-table" :class="{ 'table-overflow': tableOverflow }">
      <div class="column-header" :class="{ noBorder: isloading }">
        <div
          v-for="columnHeaderItem in columnHeader"
          :key="columnHeaderItem.id"
          class="column-header-item"
          :class="{
            tabletHide: columnHeaderItem.tabletHide,
            mobileHide: columnHeaderItem.mobileHide,
            icon: columnHeaderItem.type === 'icon',
            alignCenter: columnHeaderItem.type === 'tool-tip',
            download: columnHeaderItem.type === 'download',
            'text-align-left': columnHeaderItem.textAlignLeft,
            'no-wrap': columnHeaderItem.noWrap,
          }"
          :style="`flex: ${columnHeaderItem.width === 'auto' ? 1 : 0} 0 ${
            columnHeaderItem.width
          };width:${columnHeaderItem.width};white-space:${columnHeaderItem.whiteSpace};padding:${
            columnHeaderItem.padding
          }`"
        >
          <slot name="columnHeader" :columnHeaderItem="columnHeaderItem">
            <LvCheckbox
              v-if="columnHeaderItem.type === 'checkbox' && columnHeaderItem.selectAll"
              h3
              exclusive
              lightGray
              :value="true"
              :select="$_isSelectAll(columnHeaderItem.id)"
              @change="$_onToggleCheck($event)"
            />
            <p v-else>{{ $t(columnHeaderItem.textLabel) }}</p>
          </slot>
        </div>
      </div>
      <div class="isloading">
        <LoadingProgressBar :isloading="isloading" @completed="$_hideProgress()" />
      </div>
      <template v-if="rowData && rowData.length">
        <div
          v-for="(rowItem, rowItem_k) in rowData"
          :key="rowItem_k"
          class="data-table-row"
          :class="{ disable: disable, noTranslate: noTranslate }"
          @click="$_dataClick(rowItem)"
        >
          <div
            v-for="(columnHeaderItem, columnHeaderItem_k) in columnHeader"
            :key="columnHeaderItem_k"
            class="data-table-column"
            :class="[
              columnHeaderItem.type,
              { tabletHide: columnHeaderItem.tabletHide, mobileHide: columnHeaderItem.mobileHide },
              { overflowHide: columnHeaderItem.overflowHide },
            ]"
            :style="`flex: ${columnHeaderItem.width === 'auto' ? 1 : 0} 0 ${
              columnHeaderItem.width
            }`"
          >
            <label
              v-if="columnHeaderItem.type === 'checkbox'"
              class="checkbox"
              @click.stop="$_stopClickEvent"
            >
              <input
                type="checkbox"
                :checked="rowItem[columnHeaderItem.id]"
                @change="$_onChangeCheckState($event, rowItem)"
              />
              <div class="checkbox-icon">
                <i class="checked icon-check-box" />
                <i class="unchecked icon-check-box-outline-blank" />
              </div>
            </label>
            <button
              v-if="columnHeaderItem.type === 'rowCheckbox'"
              class="rowCheckbox pl-10"
              :class="{ fixed: columnHeaderItem.fixed }"
              @click.stop="rowCheckboxOnclick(columnHeaderItem.id, rowItem_k, rowItem.id)"
            >
              <i v-if="rowItem[columnHeaderItem.id]" class="icon-bookmark-fill" />
              <i v-else class="icon-bookmark" />
            </button>
            <div
              v-else-if="columnHeaderItem.type === 'icon' && rowItem[columnHeaderItem.id]"
              class="icon"
              :class="[
                rowItem[columnHeaderItem.id].color,
                { 'justify-left': columnHeaderItem.textAlignLeft },
              ]"
              :style="{
                color: rowItem[columnHeaderItem.id].color,
                padding: columnHeaderItem.padding,
              }"
              @click.stop="
                $_onClickIcon(columnHeaderItem.id, rowItem, rowItem_k, columnHeaderItem.snackBar)
              "
            >
              <i :class="rowItem[columnHeaderItem.id].icon" />
              <LvText h6 v-if="rowItem[columnHeaderItem.id].text" textAlign="start" class="ml-4">
                {{ $t(rowItem[columnHeaderItem.id].text) }}
              </LvText>
              <LvSnackBar
                v-if="columnHeaderItem.snackBar"
                :ref="`iconSnackBar${rowItem_k}`"
                :title="$t(columnHeaderItem.snackBar.title)"
              />
              <LvText
                v-if="columnHeaderItem.toolTip"
                white
                :h1="columnHeaderItem.toolTip.size === 'h1'"
                :h2="columnHeaderItem.toolTip.size === 'h2'"
                :h3="columnHeaderItem.toolTip.size === 'h3'"
                :h4="columnHeaderItem.toolTip.size === 'h4'"
                :h5="columnHeaderItem.toolTip.size === 'h5'"
                :h6="columnHeaderItem.toolTip.size === 'h6'"
                class="icon__tooltip"
                >{{ $t(columnHeaderItem.toolTip.text) }}</LvText
              >
            </div>
            <p
              v-else-if="columnHeaderItem.type === 'text'"
              class="text"
              :class="{
                flex: columnHeaderItem.flex,
                'text-align-left': columnHeaderItem.textAlignLeft,
                'no-wrap': columnHeaderItem.noWrap,
              }"
              :style="{
                'white-space': columnHeaderItem.whiteSpace
                  ? columnHeaderItem.whiteSpace
                  : columnHeaderItem.noWrap
                  ? 'nowrap'
                  : 'initial',
              }"
            >
              <span
                v-if="columnHeaderItem.left_text_item && rowItem.left_text_item"
                class="dot-remind-content_dot html-text"
                v-html="rowItem.left_text_item"
              />
              {{
                columnHeaderItem.isDisableI18n
                  ? rowItem[columnHeaderItem.id]
                  : $t(rowItem[columnHeaderItem.id])
              }}
            </p>
            <div
              v-else-if="columnHeaderItem.type === 'text-chip'"
              class="text"
              :class="{
                flex: columnHeaderItem.flex,
                'text-align-left': columnHeaderItem.textAlignLeft,
              }"
            >
              <span
                v-if="columnHeaderItem.left_text_item"
                class="dot-remind-content_dot html-text"
                v-html="rowItem.left_text_item"
              />
              <ContentChip
                v-if="rowItem[columnHeaderItem.id].left_chip"
                :yellow="rowItem[columnHeaderItem.id].left_chip.color === 'yellow'"
                :light-gray="rowItem[columnHeaderItem.id].left_chip.color === 'gray'"
                :orange="rowItem[columnHeaderItem.id].left_chip.color === 'orange'"
                :text-label="rowItem[columnHeaderItem.id].left_chip.text"
                :color="rowItem[columnHeaderItem.id].left_chip.color"
                class="mr-4"
              />
              <p :class="{ 'text-chip__main--max-200': columnHeaderItem.textMaxWidth200 }">
                {{ rowItem[columnHeaderItem.id].text }}
              </p>
              <ContentChip
                v-if="rowItem[columnHeaderItem.id].right_chip"
                :yellow="rowItem[columnHeaderItem.id].right_chip.color === 'yellow'"
                :light-gray="rowItem[columnHeaderItem.id].right_chip.color === 'gray'"
                :orange="rowItem[columnHeaderItem.id].right_chip.color === 'orange'"
                :text-label="rowItem[columnHeaderItem.id].right_chip.text"
                :color="rowItem[columnHeaderItem.id].right_chip.color"
                class="ml-4"
              />
              <ContentChip
                v-for="(chip, chipKey) in rowItem[columnHeaderItem.id].chips"
                :key="chipKey"
                :yellow="chip.color === 'yellow'"
                :light-gray="chip.color === 'gray'"
                :orange="chip.color === 'orange'"
                :text-label="$_getLocale(chip, 'name')"
                :color="chip.color"
                :leadingIcon="chip.leadingIcon"
                class="mr-8"
                :class="{ 'mt-8': !columnHeaderItem.flex }"
              />
            </div>
            <p v-else-if="columnHeaderItem.type === 'notification'" class="text">
              <i v-if="!rowItem.read_at" class="icon-noti-dot dot-remind-content_dot" />
              {{ rowItem[columnHeaderItem.id] }}
            </p>
            <p v-else-if="columnHeaderItem.type === 'textObject'" class="text">
              {{ rowItem[columnHeaderItem.id] ? rowItem[columnHeaderItem.id].name : $t('無') }}
            </p>
            <div
              v-else-if="columnHeaderItem.type === 'array' && rowItem[columnHeaderItem.id]"
              class="text"
            >
              <p
                v-for="(class_e, class_k) in rowItem[columnHeaderItem.id]"
                :key="class_k"
                class="text-item"
              >
                {{ $_getLocale(class_e, 'name') }}
              </p>
            </div>
            <div
              v-else-if="columnHeaderItem.type === 'badge' && rowItem[columnHeaderItem.id]"
              class="badge"
            >
              <ContentChip
                :yellow="rowItem[columnHeaderItem.id].color === 'yellow'"
                :light-gray="rowItem[columnHeaderItem.id].color === 'gray'"
                :orange="rowItem[columnHeaderItem.id].color === 'orange'"
                :green="rowItem[columnHeaderItem.id].color === 'green'"
                :text-label="$_getLocale(rowItem[columnHeaderItem.id], 'text', false)"
                :color="rowItem[columnHeaderItem.id].color"
                :isI18n="columnHeaderItem.isI18n"
              />
            </div>
            <div
              v-else-if="columnHeaderItem.type === 'badges' && rowItem[columnHeaderItem.id]"
              class="badge"
            >
              <ContentChip
                v-for="(chip, chipKey) in rowItem[columnHeaderItem.id]"
                :key="chipKey"
                :yellow="chip.color === 'yellow'"
                :light-gray="chip.color === 'gray'"
                :orange="chip.color === 'orange'"
                :text-label="$_getLocale(chip, 'text')"
                :color="chip.color"
              />
            </div>
            <div v-else-if="columnHeaderItem.type === 'chips'" class="chips-group">
              <ContentChipsList
                :chips="rowItem[columnHeaderItem.id]"
                :column="columnHeaderItem.column === undefined ? true : columnHeaderItem.column"
              />
            </div>
            <div
              v-else-if="columnHeaderItem.type === 'avatar' && rowItem[columnHeaderItem.id]"
              class="avatar"
            >
              <LlAvatar
                :circle-size="22"
                :image="rowItem[columnHeaderItem.id] ? rowItem[columnHeaderItem.id].avatar : ''"
                :text-label="rowItem[columnHeaderItem.id] ? rowItem[columnHeaderItem.id].name : ''"
                :time="rowItem[columnHeaderItem.id].time"
                :timeLabel="rowItem[columnHeaderItem.id].timeLabel"
                :subTextLabel="rowItem[columnHeaderItem.id].subTextLabel"
                :isShowDefaultAvatar="columnHeaderItem.isShowDefaultAvatar"
                :small="rowItem[columnHeaderItem.id].small"
              />
            </div>
            <div
              v-else-if="columnHeaderItem.type === 'avatars' && rowItem[columnHeaderItem.id]"
              class="avatar"
            >
              <div v-if="rowItem[columnHeaderItem.id].length">
                <LlAvatar
                  v-for="(avatar, avatarKey) in rowItem[columnHeaderItem.id]"
                  :key="avatarKey"
                  :circle-size="22"
                  :image="avatar ? avatar.avatar : ''"
                  :text-label="avatar ? avatar.name : ''"
                  :time="avatar.time"
                  :timeLabel="avatar.timeLabel"
                  :subTextLabel="avatar.subTextLabel"
                  :isShowDefaultAvatar="columnHeaderItem.isShowDefaultAvatar"
                  class="mb-3"
                />
              </div>
              <LvText v-else h6>{{ $t('無') }}</LvText>
            </div>
            <div v-else-if="columnHeaderItem.type === 'time'" class="time">
              <WsTextChip001
                v-if="rowItem[columnHeaderItem.id].text"
                font-size-sm
                icon-md
                :leading-icon="rowItem[columnHeaderItem.id].icon"
                :text-label="rowItem[columnHeaderItem.id].text"
                :gray="rowItem[columnHeaderItem.id].color === 'gray'"
                :red="rowItem[columnHeaderItem.id].color === 'red'"
              />
            </div>
            <div v-else-if="columnHeaderItem.type === 'toDoItem'" class="toDoItem">
              <WsTextChip001
                icon-md
                font-size-sm
                leading-icon="icon-check-circle-filled"
                :text-label="rowItem[columnHeaderItem.id]"
                gray
              />
            </div>
            <div v-else-if="columnHeaderItem.type === 'attaches'" class="attaches">
              <LvFileList
                small
                fullWidth
                :style="{ width: '100%' }"
                :isImagePreview="columnHeaderItem.isImagePreview"
                :value="$_getLimitList(columnHeaderItem.limit, rowItem[columnHeaderItem.id])"
                @go-to="$_onGoToFile($event)"
              />
              <p
                v-if="rowItem[columnHeaderItem.id].length > 3 && columnHeaderItem.limit"
                class="number"
              >
                +{{ rowItem[columnHeaderItem.id].length - 3 }}
              </p>
            </div>
            <div v-else-if="columnHeaderItem.type === 'list'" class="list">
              <div
                v-for="(list_e, list_k) in $_getLimitList(
                  columnHeaderItem.limit,
                  rowItem[columnHeaderItem.id],
                )"
                :key="list_k"
                class="text-list"
                :class="{ ellipsis: columnHeaderItem.ellipsis }"
              >
                {{ list_e.text }}
              </div>
            </div>
            <div v-else-if="columnHeaderItem.type === 'time-list'" class="list">
              <WsTextChip001
                v-for="(list_e, list_k) in $_getLimitList(
                  columnHeaderItem.limit,
                  rowItem[columnHeaderItem.id],
                )"
                :key="list_k"
                font-size-sm
                icon-md
                :leading-icon="list_e.icon"
                :text-label="list_e.text"
                :gray="list_e.color === 'gray'"
                :red="list_e.color === 'red'"
              />
            </div>
            <div v-else-if="columnHeaderItem.type === 'tool-tip'" class="list">
              <ChipTooltip
                v-for="(list_e, list_k) in $_getLimitList(
                  columnHeaderItem.limit,
                  rowItem[columnHeaderItem.id],
                )"
                :key="list_k"
                :leading-icon="list_e.icon"
                :text-label="list_e.text"
                :color="list_e.color"
                :tooltip-content="list_e.tooltipContent"
              />
            </div>
            <div v-else-if="columnHeaderItem.type === 'buttons'" class="buttons">
              <WsTextButton001
                v-for="(button, buttonIndex) in rowItem[columnHeaderItem.id]"
                :key="buttonIndex"
                primary
                small
                no-padding
                :leading-icon="columnHeaderItem.icon"
                @click="$_btnClick(button)"
              >
                {{ button.text }}
              </WsTextButton001>
            </div>
            <div
              v-else-if="columnHeaderItem.type === 'downloadPopup'"
              class="buttons downloadPopup"
            >
              <LlIconWithPopupMenu
                primary
                no-padding
                :leading-icon="columnHeaderItem.icon"
                :btn-list="rowItem[columnHeaderItem.id]"
                @btn-click="$_menuItemClick($event, rowItem)"
              />
            </div>
            <div v-else-if="columnHeaderItem.type === 'download'" class="download">
              <div @click="$_downloadClick()">
                <i class="icon-cloud-download" />
              </div>
            </div>
            <div v-else-if="columnHeaderItem.type === 'risk-score'" class="risk-score">
              <p>
                <span> <div class="risk-score-dot red" /> </span>Major
                {{ rowItem[columnHeaderItem.id].major }}
              </p>
              <p>
                <span> <div class="risk-score-dot yellow" /> </span>Minor
                {{ rowItem[columnHeaderItem.id].minor }}
              </p>
              <p>
                <span> <div class="risk-score-dot blue" /> </span>OFI
                {{ rowItem[columnHeaderItem.id].ofi }}
              </p>
            </div>
            <div
              v-else-if="columnHeaderItem.type === 'button' && rowItem[columnHeaderItem.id].text"
            >
              <WsButton001
                noWrap
                flatButton
                mediumButton
                :btnStyle="rowItem[columnHeaderItem.id].btnStyle"
                :leadingIcon="rowItem[columnHeaderItem.id].leadingIcon"
                @click="$emit('btn-click', rowItem)"
              >
                {{ $t(rowItem[columnHeaderItem.id].text) }}
              </WsButton001>
            </div>
            <div
              v-else-if="columnHeaderItem.type === 'iconBtn' && rowItem[columnHeaderItem.id]"
              @click.stop="$_stopClickEvent()"
            >
              <LvFlexBox justifyContent="center">
                <IconButton
                  :icon="rowItem[columnHeaderItem.id].icon"
                  :color="rowItem[columnHeaderItem.id].color"
                  :tooltipText="rowItem[columnHeaderItem.id].tooltipText"
                  @click="
                    $emit('click-icon-btn', { columnHeaderItemId: columnHeaderItem.id, rowItem })
                  "
                />
              </LvFlexBox>
            </div>
            <div
              v-else-if="columnHeaderItem.type === 'iconNavDrawer' && rowItem[columnHeaderItem.id]"
              @click.stop="$_stopClickEvent()"
            >
              <IconNavDrawer
                :navList="rowItem[columnHeaderItem.id]"
                @click="$_onClickIconNavDrawer($event, rowItem)"
              />
            </div>
            <div v-else-if="columnHeaderItem.type === 'slot'" @click.stop="$_stopClickEvent">
              <slot :rowItem="rowItem" :columnHeaderItem="columnHeaderItem" />
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import H_file from '@/helpers/file';
import H_common from '@/helpers/common';

export default {
  name: 'DataTable',
  props: {
    columnHeader: {
      type: Array,
      default() {
        return [];
      },
    },
    rowData: {
      type: Array,
      default() {
        return [];
      },
    },
    disable: {
      type: Boolean,
      default: false,
    },
    isloading: {
      type: Boolean,
      default: false,
    },
    to: {
      type: String,
      default: '',
    },
    tableOverflow: {
      type: Boolean,
      default: false,
    },
    mobileCardLayoutEnabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      noTranslate: false,
      showProgress: false,
      screenWidth: window.innerWidth,
    };
  },
  computed: {
    isMobile() {
      return this.screenWidth < 768;
    },
    isCardLayout() {
      return this.mobileCardLayoutEnabled && this.isMobile;
    },
    _cardList() {
      if (!this.isCardLayout) return [];
      return this.rowData.map(item => {
        return {
          id: item.id,
          spec: this.$_getSpecList(item),
          iconBtnList: this.$_getIconBtnList(item),
          rowItem: item,
        };
      });
    },
    _headerForCardSpec() {
      if (!this.isCardLayout) return [];
      return this.columnHeader.filter(
        ({ type }) => type === 'text' || type === 'avatar' || type === 'text-chip',
      );
    },
    _headerForCardIconBtn() {
      if (!this.isCardLayout) return [];
      return this.columnHeader.filter(({ type }) => type === 'iconBtn');
    },
  },
  watch: {
    isloading() {
      if (this.isloading) {
        this.$_showProgress();
      }
    },
  },
  mounted() {
    window.addEventListener('resize', this.$_handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.$_handleResize);
  },
  methods: {
    $_handleResize() {
      this.screenWidth = window.innerWidth;
    },
    $_showProgress() {
      this.showProgress = true;
    },
    $_hideProgress() {
      this.showProgress = false;
    },
    rowCheckboxOnclick(columnHeaderItemId, rowIndex, actId) {
      this.$emit('row-checkbox-onclick', {
        columnHeaderItemId,
        rowIndex,
        actId,
      });
    },
    $_dataClick(item) {
      let itemIds = {};
      if (item.id) {
        itemIds.id = item.id;
      }
      if (item.templateId) {
        itemIds.templateId = item.templateId;
      }
      this.$emit('click', itemIds);
      this.$emit('data-click', item);
    },
    $_tableRemoveTranslate() {
      this.noTranslate = !this.noTranslate;
    },
    $_getLimitList(limit, list) {
      if (limit && list.length > 3) {
        return list.filter((item, itemIndex) => {
          return itemIndex < 3;
        });
      }
      return list;
    },
    $_btnClick(button) {
      this.$emit('button-click', button);
    },
    $_downloadClick() {
      this.$emit('download-click');
    },
    $_menuItemClick($event, rowItem) {
      this.$emit('menu-item-click', { ...$event, rowItemData: rowItem });
    },
    $_onChangeCheckState($event, item) {
      const isChecked = $event.target.checked;
      this.$emit('check', { item, isChecked });
    },
    $_getLocale(object, textKey, isI18n) {
      return H_common.getLocale(object, textKey, isI18n);
    },
    $_onClickIcon(columnHeaderItemId, rowItem, rowItemIndex, snackBar) {
      this.$emit('click-icon', { columnHeaderItemId, rowItem });
      if (snackBar) {
        this.$refs[`iconSnackBar${rowItemIndex}`][0].$_openSnackBar();
        setTimeout(() => {
          this.$refs[`iconSnackBar${rowItemIndex}`][0].$_closeSnackBar();
        }, 2000);
      }
    },
    $_onClickIconNavDrawer($event, rowItem) {
      this.$emit('click-icon-nav-drawer', { rowItem, value: $event });
    },
    $_stopClickEvent() {
      return;
    },
    $_onGoToFile($event) {
      H_file.goToFile($event);
    },
    $_isSelectAll(columnHeaderItemId) {
      if (!this.rowData || !this.rowData.length) return false;
      return this.rowData.every(data => data[columnHeaderItemId] === true);
    },
    $_onToggleCheck($event) {
      this.$emit('check-all', $event);
    },
    $_getSpecList(item) {
      if (!this._headerForCardSpec || !this._headerForCardSpec.length) return [];
      return this._headerForCardSpec.reduce((result, header) => {
        const { id, textLabel = '', isDisableI18n = false, type = 'text' } = header;
        const value = item[id];
        if (!value || (type === 'text-chip' && !value?.text) || (type === 'avatar' && !value?.name))
          return result;
        const text = type === 'text' ? value : type === 'text-chip' ? value?.text : value?.name;
        const chips = type === 'text-chip' ? value?.chips ?? [] : [];
        result.push({
          title: textLabel,
          text: isDisableI18n || !text ? text : this.$t(text),
          chips,
        });
        return result;
      }, []);
    },
    $_getIconBtnList(item) {
      if (!this._headerForCardIconBtn || !this._headerForCardIconBtn.length) return [];
      return this._headerForCardIconBtn.reduce((result, { id: headerId }) => {
        const value = item[headerId];
        if (!value || typeof value !== 'object') return result;
        const { icon, color, tooltipText } = value;
        if (!icon) return result;
        result.push({ id: headerId, icon, color, tooltipText });
        return result;
      }, []);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/component/data-table';
</style>
